<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">
                                            <h5 class="f-w-400 p-b-30">Edit
                                                offer template for
                                                {{offer_template.role_name}}
                                                job
                                                opening</h5>
                                            <form v-on:submit.prevent="updateTemplate">
                                                <div class="form-group">
                                                    <label>Template Name:</label>
                                                    <input type="text" class="form-control" v-model="offer_template.template_name"
                                                        name="template_name" required="" />
                                                </div>
                                                <div class="form-group">
                                                    <summernote height="300" :model.sync="offer_template.body"></summernote>
                                                </div>
                                                <div class="form-group">
                                                    <input type="submit" name="submit" class="btn btn-primary" />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'
    import summernote from '../components/Summernote.vue'
    import { bus } from '../main'

    export default {
        name: 'EditOfferTemplate',

        data() {
            return {
                opening_id: '',
                offer_template: {
                    text: ''
                },
                id: ''

            }
        },

        components: {
            navbar1,
            navbar2,
            summernote
        },

        mounted() {
            this.opening_id = this.$route.params.id
            this.getTemplate()
        },
        methods: {

            getTemplate: function () {
                let template = {
                    what: 'GetOfferTemplate',
                    id: this.opening_id
                }

                this.$socket.makeGetRequest(template)
                    .then((response) => {
                        if (response.type == "GetOfferTemplate") {
                            console.log(response.data[0])
                            this.offer_template = response.data[0]
                            this.id = this.offer_template.id
                            console.log(this.offer_template.role_name)
                            bus.$emit('updateText', response.data[0].body)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            updateTemplate: function () {

                var editTemplates = {
                    what: 'GetOfferTemplate',
                    id: this.id,
                    data: this.offer_template
                }
                console.log(editTemplates)
                this.$socket.makeEditRequest(editTemplates)
                    .then((response) => {
                        console.log(response)
                        this.$swal.fire('Success', response.data.message, 'success')
                        setTimeout(() => {
                            window.location.reload()
                        }, 5000)
                    })
                    .catch((error) => {
                        console.log(error)
                        this.$swal.fire('Error', error.data.message, 'error')
                    })

            }

        },
        computed: {

        }
    }
</script>